import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import ErrorPage from '../pages/ErrorPage';
import LanguageContext from './LanguageContext'

const FaqContext = React.createContext();
const { Provider, Consumer } = FaqContext;

const FaqProvider = props => {
  const [error, setError] = useState(false);
  const [faq, setFaq] = useState([]);
  const [faqOriginal, setFaqOriginal] = useState({
    id: false,
    accountType: '',
    questions: '',
    categories: {},
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const { children, category, term, questionCategory, faqContent } = props;

  const toggleOpen = e => {
    setIsOpen(e.currentTarget.dataset.index === isOpen ? false : e.currentTarget.dataset.index);
  };

  const {language} = useContext(LanguageContext);

  const setSearch = text => {
    setSearchTerm(text);
  };

  useEffect(() => {
    if (!term) return;

    const filtered = Object.keys(faqOriginal.categories).map(categoryKey => {
      const categoryItem = faqOriginal.categories[categoryKey];
      const newCategory = { ...categoryItem };
      newCategory.questions = categoryItem.questions
        .filter(faqItem => {
          const checker = new RegExp(term, 'i');
          return checker.test(faqItem.question) || checker.test(faqItem.answer);
        })
        .map(faqItemReplace => {
          const item = { ...faqItemReplace };
          item.question = faqItemReplace.question.replace(
            RegExp(`(${term})`, 'ig'),
            '<strong>$1</strong>',
          );
          item.answer = faqItemReplace.answer.replace(
            RegExp(`(${term})`, 'ig'),
            '<strong>$1</strong>',
          );
          if (/<\/strong>/.test(item.answer)) {
            item.answerPart1 = (item.answer.match(/^(.+?<\/strong>.+?\b)/) ?? []).pop();
            item.answerPart2 = (item.answer.match(/^.+?<\/strong>.+?\b(.+)/) ?? []).pop();
          }
          return item;
        });
      return newCategory;
    });
    setFaq(filtered);
  }, [term, faqOriginal.categories]);

  useEffect(() => {
    setSearchTerm(term);
  }, [term]);

  useEffect(() => {
    setIsOpen(questionCategory || false);
  }, [questionCategory, faqOriginal]);

  useEffect(() => {
    if (!category || faqContent.dfsAccountTypes.dfsAccountTypes.length < 1) return;
    let items = false;
    try {
      items = faqContent.dfsAccountTypes.dfsAccountTypes
        .filter(acc => acc.id === category)
        .pop()
        .categories.map(cat => cat.key)
        .join(',');
    } catch {}
    axios
      .get([`/api`, `faq`, category || ''].join('/'), {
        headers:{
          'Content-Language': `${language.locale}`
        },
        params: { q: items }
      })
      .then(result => {
        result.data.questios = {};
        if (!result.data || !result.data.questions) {
          setError(true);
        } else {
          const categories = {};
          result.data.questions.map(question => {
            if (!categories[question.category.name])
              categories[question.category.name] = {
                name: question.category.name.substr(question.category.name.indexOf('-') + 1),
                key: question.category.key,
                questions: [],
              };

            question.order = question.name ?? question.question;

            categories[question.category.name].questions.push(question);
            return question;
          });
          setFaqOriginal({ ...result.data, categories });
          setError(false);
        }
      })
      .catch(e => {
        setError(true);
        // eslint-disable-next-line
        console.error('request error', e);
      });
    // eslint-disable-next-line
  }, [category, faqContent,language]);

  return error ? (
    <ErrorPage />
  ) : (
    <Provider
      value={{
        faqOriginal: faqOriginal,
        category: category,
        faq,
        searchTerm,
        toggleOpen,
        isOpen,
        setSearch,
      }}
    >
      {children}
    </Provider>
  );
};

export { FaqProvider, Consumer as ConsumerProvider };
export default FaqContext;
